<template>
  <div v-if="confirmed != null">
    <MFAEnrollmentDialog
      @change="check"
      :closeable="confirmed"
      eager
    />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import MFAEnrollmentDialog from '@/shared/components/MFAEnrollmentDialog.vue';

const confirmed = ref(null);
const store = useStore();
const router = useRouter();

async function check() {
  if (store.state.profile.workos_mfa_factor_confirmed) {
    confirmed.value = true;
    await router.push({ name: 'Dashboard' });
  } else {
    confirmed.value = false;
  }
}

onMounted(check);
</script>
